import Typography from 'components/atoms/Typography';
import { Link } from 'react-router-dom';
import { isUserThryveAdmin } from 'utils';
import { IS_PROD_ENV } from 'utils/constants';
import { useMe } from 'utils/reduxHook';
import InAppRoutes from 'utils/router';

export default function Home() {
  const me = useMe();
  const isSuperAdmin = isUserThryveAdmin(me);

  return (
    <div>
      <Typography variant="h1" className="mb-6">
        Home Page Legacy
      </Typography>
      <div className="space-y-6">
        {!isSuperAdmin && (
          <div>
            <Typography variant="h3">
              You might be in the wrong place, please go to{' '}
              <a href={IS_PROD_ENV ? 'https://app.gloo.us' : 'https://app.dev.gloo.us'} className="underline">
                Gloo App
              </a>{' '}
              to continue using Gloo.
            </Typography>
          </div>
        )}
        {isSuperAdmin && (
          <div>
            <Typography variant="h3">Super Admin Pages</Typography>
            <div className="flex flex-col space-y-2 mt-2 underline">
              <Link to={InAppRoutes.AdminAuthoringHome}>Authoring</Link>
              <Link to={InAppRoutes.AdminConversationPrompts}>Conversation Prompts</Link>
            </div>
          </div>
        )}

        <div>
          <Typography variant="h3">
            If you're looking for something else, please go to
            <br />
            <br />
            <a href={IS_PROD_ENV ? 'https://app.gloo.us' : 'https://app.dev.gloo.us'} className="underline">
              Gloo App
            </a>
            {' or '}
            <a href="https://www.gloo.us" className="underline">
              Gloo
            </a>
          </Typography>
        </div>
      </div>
    </div>
  );
}
